import nem from '../../../static/js/nem-sdk/index'

const wallet = {
  state: {
    wallet: null,
    address: '',
    publicKey: ''
  },
  getters: {
    wallet: state => state.wallet,
    address: state => state.address,
    publicKey: state => state.publicKey
  },
  mutations: {
    SET_WALLET: (state, wallet) => {
      state.wallet = wallet
    },
    SET_PP: (state, pp) => {
      state.publicKey = pp
    },
    SET_ADDRESS: (state, address) => {
      state.address = address
    }
  },
  actions: {
    createWallet({ commit, rootState }, auth) {
      const networkId = process.env.NETWORK_ID
      return new Promise((resolve, reject) => {
        // console.log(networkId)
        let wallet = nem.model.wallet.importPrivateKey(
          auth.user.email,
          auth.password,
          auth.user.passphrase,
          networkId)

        try {
          wallet = wallet.accounts[0]
          // console.log(wallet)
          let common = null
          common = nem.model.objects.create('common')(auth.password, '')
          nem.crypto.helpers.passwordToPrivatekey(common, wallet, wallet.algo)

          if (nem.crypto.helpers.checkAddress(common.privateKey, wallet.network, wallet.address)) {
            const keyPair = nem.crypto.keyPair.create(common.privateKey)
            commit('SET_WALLET', wallet)
            commit('SET_PP', keyPair.publicKey.toString())
            commit('SET_ADDRESS', wallet.address)
            resolve()
          } else {
            reject('Wrong Password')
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    storeWallet({ commit }, wallet) {
      commit('SET_WALLET', wallet)
    },
    resetWallet({ commit }) {
      commit('SET_WALLET', null)
      commit('SET_ADDRESS', '')
      commit('SET_PP', '')
    }
  }
}

export default wallet



// WEBPACK FOOTER //
// ./src/store/modules/wallet.js